import styled from 'styled-components';

export const TabsContent = styled.div`
	min-height: 50vh;
	height: fit-content;
	padding-right: 1.5rem;
`;

export const NotificationsContainer = styled.div`
	min-height: fit-content;
	.h5 {
		padding: 1rem 0;
		[type=checkbox] {
			margin-left: 1rem;
		}
	}

	fieldset {
		margin-bottom: 2rem;
	}

	.preferences-notifications-projects,
	.preferences-notifications-asset-types{
		margin-bottom: 4rem;
		.btn-menu-react-select__menu {
			margin-bottom: 0;
			&-list {
				max-height: 10rem;
			}
		}
	}
`;
export const ProfileContainer = styled.div`
	.h5 {
		padding: 1rem 0;

		[type=checkbox] {
			margin-left: 1rem;
		}
	}

	fieldset {
		margin-bottom: 2rem;
	}
`;
export const IngestContainer = styled.div`
	fieldset {
		width:100%;
		padding-top:15px;
	}

	fieldset > div {
		display: flex;
		flex-direction: row;
		align-items: center;
		margin-bottom: 0.5rem;
		height: 30px;
	}

	label {
		width: 40rem;
	}

	input{
		display: inline-block;
		width: 4rem;
		text-align:center;
	}
`;

export const EmailPreference = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 24rem;
	margin-bottom: 1rem;

	label {
		width: 12rem;
		margin-right: 1.5rem;
	}

	.email-preference {
		flex: 1 1 0;
	}
`;

export const ContactListContainer = styled.div`
	fieldset {
		margin-bottom: 2rem;
	}
`;

export const AddContactListContainer = styled.div`
	.add-contact-btn {
		display: block;
		margin: 0 0 1rem auto;
	}
`;

export const AddContactListForm = styled.div`
	label {
		margin-top: 1rem;
	}

	fieldset {
		margin-bottom: 2rem;
	}
`;

export const ContactListsContainer = styled.div`
	padding-left: 0.5rem;
	width: 5rem;
`;

export const ContactsContainer = styled.div`
	display: flex;
	align-items: center;
	margin-bottom: 1.5rem;
	
	& > div {
		&:first-child {
			flex: 1 1 0;
			max-width: 50em;
		}
	}
`;

export const ProfilePreferencesSmallLegend = styled.span`
	font-size: 0.8rem;
	color: ${({ theme }) => theme['silver-base']};
	font-weight: 500;
	padding: 0 1rem;
`;
